module.exports = __webpack_public_path__ + "static/img/16bg_4.d5149dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/16bg_4.png
// module id = 660
// module chunks = 1